import { TagData } from 'data/models/TaskTags';
import { RootState } from 'data/store';

export const selectPartnerTaskTags = (state: RootState): Array<TagData> => state.taskTags.tags ?? [];
export const selectTaskTagsIsLoading = (state: RootState): boolean => state.taskTags.isLoading;
